import { render, staticRenderFns } from "./CertificateLists.vue?vue&type=template&id=6068004c&scoped=true&"
import script from "./CertificateLists.vue?vue&type=script&lang=js&"
export * from "./CertificateLists.vue?vue&type=script&lang=js&"
import style0 from "./CertificateLists.vue?vue&type=style&index=0&id=6068004c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6068004c",
  null
  
)

export default component.exports